import { render, staticRenderFns } from "./DropdownTableElementComponent.vue?vue&type=template&id=4bf7ce92&"
import script from "./DropdownTableElementComponent.vue?vue&type=script&lang=ts&"
export * from "./DropdownTableElementComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf7ce92')) {
      api.createRecord('4bf7ce92', component.options)
    } else {
      api.reload('4bf7ce92', component.options)
    }
    module.hot.accept("./DropdownTableElementComponent.vue?vue&type=template&id=4bf7ce92&", function () {
      api.rerender('4bf7ce92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Elements/DropdownTableElementComponent.vue"
export default component.exports